import { DeleteFilled } from "@ant-design/icons";
import { Form, Spin, Upload } from "antd";
import "antd/dist/antd.min.css";
import PropTypes from "prop-types";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { postRequest } from "../../../axios";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import UploadFileIcon from "../../../image/AddCsv.png";
import FileAltLabel from "../../../image/DownloadSample.svg";
import "../../../styles/Main.scss";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../../utils/Notifications";
const bucketUrl = process.env.REACT_APP_BUCKET_URL;

// state initiailisation
const BulkCategoryUpload = ({
  newCategoryAdded,
  setNewCategoryAdded,
  handleCancelBulk,
}) => {
  const { t } = useTranslation();
  const { Dragger } = Upload;
  const [uploadFile, setUploadFile] = useState("");
  const [apiloading, setapiLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [fileName, setFileName] = useState(null);

  const formRef = useRef();

//  Function to handle cancellation OR Back To List
  const backToList = () => {
    handleCancelBulk();
    handleDeleteFile();
  };

  // Function to Handle Submit
  const handleSubmit = async () => {
    try {
      setBtnLoading(true);

      if (!uploadFile) {
        ErrorNotificationMsg(t("msg_pleaseUploadFile"));
        setBtnLoading(false);
        return;
      }

      const formData = new FormData();
      formData.append("upload_file", uploadFile);
      setapiLoading(true);

      const apiResponse = await postRequest(
        "categorytree-bulk-upload/",
        formData
      );
      if (apiResponse.data.status) {
        SuccessNotificationMsg(t("msg_uploadSuccess"));
        setBtnLoading(false);
        handleDeleteFile();
        setNewCategoryAdded(!newCategoryAdded);
        handleCancelBulk();
      } else {
        ErrorNotificationMsg(apiResponse.data.message);

        setBtnLoading(false);
      }
      setapiLoading(false);
    } catch (error) {
      setBtnLoading(false);
      setapiLoading(false);
    }
  };

  // Function to Delete the File
  const handleDeleteFile = () => {
    setUploadFile("");
    setFileName(null);
  };

  // Function to Upload Props
  const uploadProps = {
    accept: ".csv",
    showUploadList: false,
    beforeUpload: (file) => {
      setUploadFile(file);
      setFileName(file.name);
      return false;
    },
  };

  return (
    <div className="uploadwrap">
      <div className="uploadinside">
        <div className="ImportCSV">
          <Spin spinning={apiloading}>
            <Form className="ModalForm" autoComplete="off" ref={formRef}>
              <Dragger {...uploadProps}>
                <div className="AddCssIcon">
                  <Link>
                    {" "}
                    <img
                      className="BulkDownload"
                      src={UploadFileIcon}
                      alt=""
                    />{" "}
                  </Link>
                </div>

                <h2>Drag and drop your CSV file here</h2>
                <h3>Or select file your computer</h3>
              </Dragger>

              <div className="UploadedFileIcon">
                {fileName}

                {uploadFile && (
                  <DeleteFilled
                    className="DeleteGradiantBtn"
                    label="Delete"
                    onClick={handleDeleteFile}
                  />
                )}
              </div>

              <div className="DnlSempleFile">
                <h2>Download Sample File From Here</h2>
                <span>
                  {" "}
                  <a
                    href={bucketUrl}
                  >
                    <img
                      className="BulkDownloadIcon"
                      src={FileAltLabel}
                      alt=""
                    />{" "}
                    Get CSV Sample
                  </a>
                </span>
              </div>

              <div className="ModalPopupFooter mt-0">
                <ButtonField
                  className="CancelGradiantBtn"
                  type="primary"
                  htmlType="button"
                  label={t("cancel")}
                  onClick={backToList}
                />

                <ButtonField
                  className="SaveGradiantBtn"
                  label={t("import")}
                  htmlType="Submit"
                  onClick={handleSubmit}
                  loading={btnLoading}
                />
              </div>
            </Form>
          </Spin>
        </div>
      </div>
    </div>
  );
};

BulkCategoryUpload.propTypes = {
  handleCancelBulk: PropTypes.func.isRequired,
  newCategoryAdded: PropTypes.bool.isRequired,
  setNewCategoryAdded: PropTypes.func.isRequired,
};

export default BulkCategoryUpload;
